module.exports = __webpack_public_path__ + "static/img/ggsc1.b9333b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/ggsc1.jpg
// module id = Lqd4
// module chunks = 0